// extracted by mini-css-extract-plugin
export default {"text":"Picker_text__CyJ3T","snackbar":"Picker_snackbar__RMAXI","rightArrowSnackbar":"Picker_rightArrowSnackbar__0PGlq","copiedMessage":"Picker_copiedMessage__QA8M0"};